import React from "react";
import { SectionContainerBase } from "@reusejs/react";

export interface HeadingWithListProps {
  heading: string;
  headingStyles?: string;
  listType?: string;
  para?: React.ReactNode;
  elementWrapperStyles?: string;
  listElements: string[] | JSX.Element[];
  listElementStyle?: string;
  outerContainerStyles?: string;
  innerContainerStyles?: string;
}

export const HeadingWithList = (props: HeadingWithListProps) => {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles:
          props.outerContainerStyles ||
          "w-full px-4 mx-auto mt-2 md:mb-10 md:w-10/12 lg:w-7/12 xl:w-5/12",
        innerContainerStyles: props.innerContainerStyles || "relative",
      }}
    >
      <div
        className={
          props.headingStyles || "font-bold text-lg md:text-2xl pt-2 md:py-4"
        }
      >
        {props.heading}
      </div>
      {props.para}
      <div className={props.elementWrapperStyles || "ml-6 md:ml-10"}>
        <ol
          className="marker:text-gray-500 marker:font-medium"
          style={{ listStyleType: props.listType || "lower-alpha" }}
        >
          {props.listElements.map((element, index) => (
            <li key={index}>{element}</li>
          ))}
        </ol>
      </div>
    </SectionContainerBase>
  );
};
